import { createSelector } from 'reselect'

import { getCurrentAccount } from 'state/selectors/accountSelector'
import copy from 'fast-copy'

export const getAccountUsers = (state, includeGuests = false) => {
  const account = copy(getCurrentAccount(state))

  let users = []

  if(account){
    account.users.forEach(userId => {
      if(!includeGuests && account.guestIds.indexOf(userId) == -1){
        const user = state.account.entities.users[userId]
        users.push(user)
      }
    })
  }

  return users;
}

export const getUserById = (state, id) => (
    state.account.entities.users[id]
)

export const getCurrentUser = (state, force) => {
	if(!state.auth.userId || !state.account.entities.users){
		return null
  }

  const user = state.account.entities.users[state.auth.userId]

  if(!user){
    return null
  }

  return user
}

export const getUserFromSelection = (users, id) => {
  let user = users.find(user => {
    return user.id === id
  })

  return user
}

export const isCurrentUserAdmin = (state) => {
  const user = getCurrentUser(state, false)
  const account = getCurrentAccount(state)

  if(!user || !account){
    return false;
  }

  const isAdmin = account.adminIds.indexOf(user.id) !== -1;

  return isAdmin
}

export const getUserRoles = createSelector(
	[
		(state, tempUser) => tempUser ? tempUser : getCurrentUser(state),
		state => getCurrentAccount(state)
	],
	(user, account) => {
    // assume guest unless proven otherwise
    let roles = {
      guest: true,
      pm: false,
      admin: false
    }
  
    if(user && account){
      if(account.guestIds && account.adminIds.indexOf(user.id) !== -1){
        roles.admin = true
      }
  
      if(account.guestIds && account.pmIds.indexOf(user.id) !== -1){
        roles.pm = true
      }
  
      if(account.guestIds && account.guestIds.indexOf(user.id) == -1){
        roles.guest = false
      }
    }
  
    return roles
	}
)

export const isCurrentUserGuest = state => {
  const roles = getUserRoles(state)

  return roles.guest
}

export const getAllGuests = state => {
  const account = getCurrentAccount(state)

  let guestsArray = []

  if(account && account.guestIds){
    account.guestIds.forEach(guestId => {
      let guestObject = state.account.entities.users[guestId]

      if(guestObject){
        guestsArray.push(guestObject)
      }
    })
  }

  return guestsArray
}


// WEBPACK FOOTER //
// ./src/state/selectors/userSelectors.jsx